import { Injectable, signal } from "@angular/core";
import { environment } from "src/environments/environment";

@Injectable({
    providedIn: "root",
})
export class PragmaAgentLoaderService {
    private static readonly embedUnavailableMessage =
        "The Pragma Agent assistant could not be loaded and is currently unavailable.";

    private loadingPromise: Promise<void> | null = null;
    private script: HTMLScriptElement | null = null;

    readonly embedReady = signal(false);

    loadEmbed(): Promise<void> {
        if (this.embedReady()) {
            return Promise.resolve();
        }

        if (this.loadingPromise) {
            return this.loadingPromise;
        }

        const existingScript = document.querySelector(
            "script[data-pragma-embed]",
        );
        if (existingScript) {
            this.loadingPromise = this.waitForCustomElement();
            return this.loadingPromise;
        }

        this.loadingPromise = new Promise((resolve, reject) => {
            this.script = document.createElement("script");
            this.script.src = environment.pragmaAgentEmbedUrl;
            this.script.setAttribute("data-pragma-embed", "true");
            this.script.async = true;

            this.script.onload = () => {
                this.waitForCustomElement().then(resolve).catch(reject);
            };

            this.script.onerror = () => {
                this.loadingPromise = null;
                reject(
                    new Error(PragmaAgentLoaderService.embedUnavailableMessage),
                );
            };

            document.head.appendChild(this.script);
        });

        return this.loadingPromise;
    }

    getEmbedUnavailableMessage(): string {
        return PragmaAgentLoaderService.embedUnavailableMessage;
    }

    private waitForCustomElement(): Promise<void> {
        return new Promise((resolve) => {
            const check = () => {
                if (customElements.get("pragma-agent")) {
                    this.embedReady.set(true);
                    resolve();
                    return;
                }
                setTimeout(check, 50);
            };
            check();
        });
    }
}
